<ccl-section-wrapper>
    <ccl-content-section>
        <router-outlet></router-outlet>
    </ccl-content-section>
</ccl-section-wrapper>